import { Grid, SvgIconProps } from "@mui/material";
import { Card, CardContent, Typography, Box, Avatar } from "@mui/material";
import Loader from "../../components/Generics/Loader";

type Props = {
  title: string;
  value: string | number;
  icon: (props: SvgIconProps) => JSX.Element | any;
  color: string;
  permissao: boolean;
  loading: boolean;
};

const CardInformativo = (props: Props) => {
  const { title, value, icon, color, permissao, loading } = props;

  if (!permissao) return null;

  const IconComponent = icon;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid
          container
          spacing={2}
          xs={12}
          style={{ justifyContent: "center" }}
        >
          <Grid item>
            {permissao && (
              <Card
                variant="outlined"
                sx={{
                  width: 300,
                  "&:hover": {
                    boxShadow: 4,
                    transition: "box-shadow 0.3s ease",
                  },
                }}
              >
                <CardContent sx={{ display: "flex", alignItems: "center" }}>
                  <Avatar sx={{ bgcolor: color, mr: 2 }}>
                    <IconComponent style={{ color: "#fff" }} />
                  </Avatar>
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      {title}
                    </Typography>
                    <Box display="flex" alignItems="baseline">
                      {loading ? (
                        <div style={{ textAlign: "center" }}>
                          <Loader size={25} />
                        </div>
                      ) : (
                        <Typography variant="h5" fontWeight="bold">
                          {value}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CardInformativo;
